module.exports = __webpack_public_path__ + "static/media/tax-fillings.7dcbd2d6.png";